/* eslint-disable no-undef */
import angular from 'angular';

export function FormatterService() {
    const getCurrencyFormatter = (currencyCode) => {
        if (currencyCode) {
            return new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 0,
            });
        }
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 0,
        });
    };

    return {
        getCurrencyFormatter,
    };
}

export const formatValue = FormatterService => value => FormatterService.getCurrencyFormatter().format(value || '');

angular.module('TALENYA-FE').factory('FormatterService', FormatterService);

angular.module('TALENYA-FE').filter('formatValue', formatValue);
